<template>
  <component
    :is="componentType"
    :type="!link ? type : false"
    :to="redirectionLink"
    class="button button-secondary"
    :class="{ 'disabled': disabled }"
    data-testid="subscribeSubmit"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>
      Button
    </slot>
  </component>
</template>
<script>
import BaseButton from './BaseButton'

export default {
  name: 'ButtonSecondary',
  mixins: [ BaseButton ]
}
</script>
